var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChosefor2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7102 21.0005C9.23618 21.0005 9.66258 20.5741 9.66258 20.0481C9.66258 19.5221 9.23618 19.0957 8.7102 19.0957C8.18421 19.0957 7.75781 19.5221 7.75781 20.0481C7.75781 20.5741 8.18421 21.0005 8.7102 21.0005Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1868 21.0005C19.7127 21.0005 20.1391 20.5741 20.1391 20.0481C20.1391 19.5221 19.7127 19.0957 19.1868 19.0957C18.6608 19.0957 18.2344 19.5221 18.2344 20.0481C18.2344 20.5741 18.6608 21.0005 19.1868 21.0005Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.09375 1H4.90329L7.45568 13.7524C7.54277 14.1909 7.78131 14.5848 8.12954 14.8651C8.47776 15.1454 8.91349 15.2943 9.36045 15.2858H18.6176C19.0646 15.2943 19.5003 15.1454 19.8485 14.8651C20.1968 14.5848 20.4353 14.1909 20.5224 13.7524L22.0462 5.76192H5.85567",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChosefor2);
export default __webpack_public_path__ + "static/media/chosefor2.dc9cb8a4322a4efaa55637894a55effd.svg";
export { ForwardRef as ReactComponent };